import {
  handleError,
  getHeaderInfo,
  getPatientIntakeEndpoint
} from './apiUtils';

export async function getExpiryStatus(secureID) {
  return fetch(getPatientIntakeEndpoint(`patient-intake/${secureID}`), getHeaderInfo())
    .then((resp) => resp?.json())
    .catch(handleError);
}

export async function validateUser(secureID, formData) {
  const { method, headers } = getHeaderInfo('POST');
  const fixedHeaders = {
    ...headers,
    'Content-Type': 'application/vnd.api+json',
  };
  const params = {
    method,
    headers: fixedHeaders,
    body: JSON.stringify(formData),
  };
  return fetch(getPatientIntakeEndpoint(`patient-intake/${secureID}/validate`), params)
    .then((resp) => resp?.json())
    .catch(handleError);
}

export async function getDocuments(secureID, securedToken) {
  const { method, headers } = getHeaderInfo();  
  const fixedHeaders = {
    ...headers,
    'X-Secure-Token': securedToken,
  };
  const params = {
    method,
    headers: fixedHeaders,
    redirect: 'follow'
  };
  return fetch(getPatientIntakeEndpoint(`patient-intake/${secureID}/get-documents`), params)
    .then((resp) => resp?.json())
    .catch(handleError);
}

export async function fetchDocument(secureID, securedToken, docId) {
  const { method, headers } = getHeaderInfo();  
  const fixedHeaders = {
    ...headers,
    'X-Secure-Token': securedToken,
  };
  const params = {
    method,
    headers: fixedHeaders,
  };
  return fetch(getPatientIntakeEndpoint(`patient-intake/${secureID}/fetch-document/${docId}`), params)
    .then((resp) => resp?.json())
    .catch(handleError);
}


